@if (allowedFileExtensions && showUi) {
    <div
        class="detail-page-card"
        [class.m-0]="noMargin"
        [class.compact-document-manager]="compactMode"
        [class.no-documents]="folderData.length === 0"
        fileDrop
        (fileDrop)="fileDropHandler($event)"
        [allowedExtensions]="allowedFileExtensions"
        [allowDrop]="permissions.canAddDocument"
    >
        <ng-container>
            @if (!hideLabel && Label) {
                <div class="detail-page-card-title">{{ Label }}</div>
            }
            @if (!hideAddFolderButton || !hideAddButton || !hideGenerateButton) {
                <div class="detail-page-card-actions">
                    <button
                        data-uiid="documentmanager-addfolder"
                        class="btn btn-raised"
                        (click)="openAddFolder()"
                        [disabled]="disabled || !permissions.canAddFolder"
                    >
                        <i class="fas fa-plus-circle"></i>
                        <span>Add folder</span>
                    </button>
                    <button
                        data-uiid="documentmanager-adddocument"
                        class="btn btn-raised"
                        (click)="openEditFile()"
                        [disabled]="disabled || !permissions.canAddDocument"
                    >
                        <i class="fas fa-plus-circle"></i>
                        <span>Add document</span>
                    </button>
                    <button
                        data-uiid="documentmanager-generatedocument"
                        class="btn btn-raised"
                        (click)="openGenerate()"
                        [disabled]="disabled || !permissions.canAddDocument"
                    >
                        <i class="fas fa-plus-circle"></i>
                        <span>Generate document</span>
                    </button>
                    <div class="spacer"></div>
                    <button
                        data-uiid="documentmanager-cutselection"
                        class="btn btn-raised"
                        (click)="cutSelectedRows()"
                        [disabled]="disabled || cutRows.length > 0"
                    >
                        <i class="fas fa-scissors"></i>
                        <span>Cut selection</span>
                    </button>
                    <button
                        data-uiid="documentmanager-pasteselection"
                        class="btn btn-raised"
                        (click)="pasteSelectedRows()"
                        [disabled]="disabled || cutRows.length === 0"
                    >
                        <i class="fas fa-paste"></i>
                        <span>Paste selection</span>
                    </button>
                </div>
            }

            @if (folderData.length > 0 || folderPath.length > 0) {
                <div class="document-grid">
                    <div class="document-grid-breadcrumbs">
                        <div class="document-grid-breadcrumbs-crumb" (click)="navigateBreadcrumb()">
                            <i class="fas fa-house"></i>
                        </div>
                        @for (crumb of folderPath; track crumb.Guid) {
                            <div class="document-grid-breadcrumbs-separator">
                                <i class="fas fa-chevron-right"></i>
                            </div>
                            <div
                                class="document-grid-breadcrumbs-crumb"
                                (click)="navigateBreadcrumb(crumb)"
                            >
                                {{ crumb.Name }}
                            </div>
                        }
                    </div>
                    @if (folderData) {
                        <ejs-grid
                            [dataSource]="folderData"
                            [filterSettings]="_filterOptions"
                            [sortSettings]="_sortColumnOptions"
                            [showColumnMenu]="true"
                            [allowReordering]="true"
                            [allowResizing]="true"
                            [allowFiltering]="true"
                            [allowSorting]="true"
                            [enableHover]="true"
                            [selectionSettings]="selectionOptions"
                            [contextMenuItems]="contextMenuItems"
                            (contextMenuClick)="contextMenuClick($event)"
                            (recordClick)="singleClickAction($event)"
                            (recordDoubleClick)="openEdit($event)"
                            #ejGrid
                        >
                            <e-columns>
                                <e-column
                                    type="checkbox"
                                    field="IsSelected"
                                    width="20"
                                    [uid]="selectionColumnName"
                                    [allowResizing]="false"
                                    [allowFiltering]="false"
                                    [showColumnMenu]="false"
                                ></e-column>
                                <e-column field="Name" headerText="Name">
                                    <ng-template #template let-data>
                                        @if (!data.IsNew && !data.Edited && !data.Deleted) {
                                            @if (data.msFileIcon) {
                                                <span class="mat-icon-workaround">
                                                    <mat-icon
                                                        [svgIcon]="data.msFileIcon"
                                                    ></mat-icon>
                                                </span>
                                            } @else {
                                                @if (data.FileType == FileType.Document) {
                                                    <i class="fas fa-{{ data.FileIcon }}"></i>
                                                }
                                            }
                                        } @else if (data.IsNew) {
                                            @switch (data.FileType) {
                                                @case (FileType.Document) {
                                                    <i class="fas fa-plus"></i>
                                                }
                                                @case (FileType.Folder) {
                                                    <i class="fas fa-folder-plus"></i>
                                                }
                                            }
                                        }

                                        @if (
                                            data.FileType === FileType.Folder &&
                                            !data.IsNew &&
                                            !data.Deleted &&
                                            data.FileIcon
                                        ) {
                                            <cerrix-icon-viewer
                                                [icon]="data.FileIcon"
                                            ></cerrix-icon-viewer>
                                        }
                                        @if (data.Edited) {
                                            <i class="fas fa-pencil"></i>
                                        }
                                        @if (data.Deleted) {
                                            <i class="fas fa-times"></i>
                                        }

                                        <span
                                            class="document-name ms-2"
                                            [class.red]="data.Deleted"
                                            [class.cut]="data.IsCut"
                                        >
                                            {{ data.Name }}
                                            @if (data.Changed) {
                                                <i>(edited)</i>
                                            }
                                        </span>
                                    </ng-template>
                                </e-column>
                                <e-column
                                    field="Description"
                                    headerText="Description"
                                    [visible]="false"
                                ></e-column>
                                <e-column
                                    field="Username"
                                    headerText="User"
                                    [visible]="!compactMode"
                                ></e-column>
                                <e-column headerText="Date uploaded" [visible]="!compactMode">
                                    <ng-template #template let-data>{{
                                        data.Date | dateTimeFormat: true
                                    }}</ng-template>
                                </e-column>
                                <e-column
                                    field="DocumentType"
                                    headerText="Document type"
                                    [visible]="!compactMode"
                                ></e-column>
                                <e-column
                                    field="Version"
                                    headerText="# of versions"
                                    [visible]="false"
                                ></e-column>

                                @for (col of ExtraFieldColumnConfig; track col.fieldName) {
                                    <e-column
                                        [field]="col.fieldName"
                                        [headerText]="col.prettyName"
                                        [width]="col.columnWidth"
                                        [visible]="!col.hidden"
                                    >
                                    </e-column>
                                }

                                <e-column
                                    width="40"
                                    textAlign="Center"
                                    [allowEditing]="false"
                                    [allowResizing]="false"
                                    [uid]="fileMenuColumnName"
                                >
                                    <ng-template #template let-data>
                                        <i
                                            class="fas fa-bars"
                                            mat-icon-button
                                            [matMenuTriggerFor]="docManagerFileMenu"
                                        ></i>
                                        <mat-menu #docManagerFileMenu="matMenu">
                                            @if (!data.IsNew) {
                                                @if (!data.Deleted) {
                                                    @if (data.WopiViewable) {
                                                        <button
                                                            mat-menu-item
                                                            (click)="
                                                                openEmbedView(data);
                                                                cerrixSlideOverWopi.show();
                                                                $event.stopPropagation()
                                                            "
                                                        >
                                                            <mat-icon
                                                                [svgIcon]="data.msAppIcon"
                                                            ></mat-icon>
                                                            <span>View in Office for the web</span>
                                                        </button>
                                                    }
                                                    @if (
                                                        !disabled && AllowEdit && data.WopiEditable
                                                    ) {
                                                        <button
                                                            mat-menu-item
                                                            (click)="
                                                                openEditorInWindow(data);
                                                                $event.stopPropagation()
                                                            "
                                                        >
                                                            <mat-icon
                                                                [svgIcon]="data.msAppIcon"
                                                            ></mat-icon>
                                                            <span>Edit in Office for the web</span>
                                                        </button>
                                                    }
                                                }

                                                @if (data.Name && data.Name.endsWith(".pdf")) {
                                                    <button
                                                        mat-menu-item
                                                        (click)="openDocumentViewer(data)"
                                                    >
                                                        <mat-icon
                                                            fontSet="fas"
                                                            fontIcon="fa-file-pdf"
                                                        ></mat-icon>
                                                        <span>Open PDF Viewer</span>
                                                    </button>
                                                }
                                            }

                                            @if (data.FileType === FileType.Document) {
                                                <a
                                                    mat-menu-item
                                                    [href]="
                                                        'api/documents/manager/' +
                                                        data.Guid +
                                                        '/data'
                                                    "
                                                    target="_blank"
                                                >
                                                    <mat-icon
                                                        ><i class="fas fa-download"></i
                                                    ></mat-icon>
                                                    <span>Download</span>
                                                </a>
                                            }
                                            @if (!disabled && data.CanDelete && AllowDelete) {
                                                <button mat-menu-item (click)="toggleDelete(data)">
                                                    @if (data.Deleted) {
                                                        <mat-icon
                                                            ><i class="fas fa-undo"></i
                                                        ></mat-icon>
                                                    } @else {
                                                        <mat-icon
                                                            ><i class="fas fa-trash"></i
                                                        ></mat-icon>
                                                    }
                                                    <span>{{
                                                        data.Deleted ? "Undo delete" : "Delete"
                                                    }}</span>
                                                </button>
                                            }
                                        </mat-menu>
                                    </ng-template>
                                </e-column>
                            </e-columns>
                        </ejs-grid>
                    }
                </div>
            }
        </ng-container>

        @if (folderData.length === 0) {
            <div class="no-documents-area-container">
                <div class="no-documents-area">
                    <div class="no-documents-text">
                        <i class="fas fa-info-circle fa-fw me-2 primary-color"></i>
                        <span class="fw-bold">No documents are uploaded</span>
                    </div>
                    @if (!hideAddButton && !disabled && permissions.canAddDocument) {
                        <div class="add-first-document-section">
                            <span class="fw-bold primary-color">
                                <i class="far fa-arrow-to-bottom me-2"></i>
                                <span>Drag your documents here to start uploading</span>
                            </span>
                        </div>
                    }
                </div>
            </div>
        }
    </div>
}

<cerrix-slide-over-wopi
    #cerrixSlideOverWopi
    [title]="slideOutTitle"
    [wopiData]="slideOutContent"
></cerrix-slide-over-wopi>
